/* ============================================================
   ES Naturals Theme — Main JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Sticky header scroll effect ──────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // ── Mobile nav ───────────────────────────────────────────
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileNavOverlay = document.querySelector('.mobile-nav-overlay');
  const mobileNavClose = document.querySelector('.mobile-nav-close');

  function openMobileNav() {
    if (mobileNav) { mobileNav.classList.add('open'); document.body.style.overflow = 'hidden'; }
  }
  function closeMobileNav() {
    if (mobileNav) { mobileNav.classList.remove('open'); document.body.style.overflow = ''; }
  }

  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);

  // ── Cart Drawer ───────────────────────────────────────────
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartBtns = document.querySelectorAll('[data-open-cart]');
  const cartClose = document.querySelector('.cart-drawer-close');

  function openCart() {
    if (cartDrawer) { cartDrawer.classList.add('open'); }
    if (cartOverlay) { cartOverlay.classList.add('open'); }
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) { cartDrawer.classList.remove('open'); }
    if (cartOverlay) { cartOverlay.classList.remove('open'); }
    document.body.style.overflow = '';
  }

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ── Scroll-triggered fade-up animations ──────────────────
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

  // ── Product image thumbnails ──────────────────────────────
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImage = document.querySelector('.product-main-image img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImage) {
        mainImage.src = thumb.querySelector('img').src;
        mainImage.alt = thumb.querySelector('img').alt;
      }
    });
  });

  // ── Add to Cart ───────────────────────────────────────────
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async function () {
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const originalText = this.textContent;
      this.textContent = 'Adding…';
      this.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          await updateCartCount();
          openCart();
          await renderCartItems();
        }
      } catch (e) {
        console.error('Add to cart error:', e);
      } finally {
        this.textContent = originalText;
        this.disabled = false;
      }
    });
  });

  // ── Cart helpers ──────────────────────────────────────────
  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function updateCartCount() {
    const cart = await getCart();
    const countEls = document.querySelectorAll('.cart-count');
    countEls.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  }

  async function renderCartItems() {
    const cart = await getCart();
    const body = document.querySelector('.cart-drawer-body');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-empty">
          <p>Your cart is empty.</p>
          <a href="/collections/all" class="btn btn-primary" id="cart-empty-shop-btn">Shop Now</a>
        </div>`;
      return;
    }

    const itemsHtml = cart.items.map(item => `
      <div class="cart-item">
        <div class="cart-item-image">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
        </div>
        <div class="cart-item-details">
          <div class="cart-item-title">${item.product_title}</div>
          <div class="cart-item-price">${formatMoney(item.price)}</div>
          <div class="cart-item-qty">
            <button class="qty-btn" data-change-qty="${item.key}" data-delta="-1">−</button>
            <span class="qty-num">${item.quantity}</span>
            <button class="qty-btn" data-change-qty="${item.key}" data-delta="1">+</button>
          </div>
        </div>
      </div>`).join('');

    const subtotal = `<div class="cart-subtotal"><span>Subtotal</span><span>${formatMoney(cart.total_price)}</span></div>`;
    const checkout = `<a href="/checkout" class="cart-checkout-btn">Checkout →</a>`;

    body.innerHTML = itemsHtml;

    const footer = document.querySelector('.cart-drawer-footer');
    if (footer) footer.innerHTML = subtotal + checkout;

    // Qty change listeners
    body.querySelectorAll('[data-change-qty]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.changeQty;
        const delta = parseInt(btn.dataset.delta);
        const item = cart.items.find(i => i.key === key);
        if (!item) return;
        const newQty = Math.max(0, item.quantity + delta);
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        });
        await updateCartCount();
        await renderCartItems();
      });
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Init cart count on load
  updateCartCount();

  // ── Filter tabs — filter product cards by data-category ───
  document.querySelectorAll('.filter-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.filter-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      const filter = tab.dataset.filter;
      document.querySelectorAll('.product-card').forEach(card => {
        if (filter === 'all') {
          card.style.display = '';
        } else {
          const cats = (card.dataset.category || '').toLowerCase();
          card.style.display = cats.includes(filter) ? '' : 'none';
        }
      });
    });
  });

  // Close empty-cart shop button (delegated, since it's injected dynamically)
  document.addEventListener('click', function(e) {
    if (e.target && e.target.id === 'cart-empty-shop-btn') {
      closeCart();
    }
  });

});
